import { Component, Optional } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

interface OptionsPrint {
  printStore: boolean;
  printQuantity: boolean;
}

@Component({
  selector: 'app-print-predevolution-modal',
  templateUrl: './print-predevolution-modal.component.html',
  styleUrls: ['./print-predevolution-modal.component.scss'],
  standalone: false
})
export class PrintPredevolutionModalComponent {

  formOptionPrint: FormGroup = new FormGroup({});

  constructor(private formBuilder: FormBuilder,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm({ printStore: true, printQuantity: true });
  }

  printPredevolution() {
    const modelOptionsPrint = this.formOptionPrint.value as OptionsPrint;
    if (!modelOptionsPrint.printStore && !modelOptionsPrint.printQuantity) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe seleccionar al menos una de las dos opciones.'
      );
      return;
    }
    const data: ModalObjectType = {};
    data.params = {
      printStore: modelOptionsPrint.printStore,
      printQuantity: modelOptionsPrint.printQuantity
    };
    this.ref.close(data);
  }

  validateForm(optionsPrint: OptionsPrint) {
    this.formOptionPrint = this.formBuilder.group({
      printStore: [optionsPrint.printStore],
      printQuantity: [optionsPrint.printQuantity]
    });
  }

}
